// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__-4Bsx","title":"AfterBackImages_title__3GmC9","images":"AfterBackImages_images__25vmu"};